(() => {
  if (window.__kbWeebeCartBadge) return;
  window.__kbWeebeCartBadge = true;

  const refreshCartIconBubble = () => {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    fetch(`${root}?section_id=cart-icon-bubble`)
      .then((response) => (response.ok ? response.text() : Promise.reject()))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const fresh = doc.querySelector("#shopify-section-cart-icon-bubble, .shopify-section");
        const current = document.getElementById("cart-icon-bubble");
        if (!fresh || !current) return;
        current.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  };

  window.addEventListener("CART_ITEM_ADDED", refreshCartIconBubble);
  window.addEventListener("UPDATE_CART", refreshCartIconBubble);

  const fetchCart = window.fetch.bind(window);
  window.fetch = function (input, init) {
    const result = fetchCart(input, init);
    try {
      const url = typeof input === "string" ? input : input && input.url;
      if (url && /\/cart\/change/.test(url)) {
        result
          .then((response) => {
            if (response && response.ok) refreshCartIconBubble();
          })
          .catch(() => {});
      }
    } catch (e) {}
    return result;
  };
})();
